<template>
    <svg
        id="Layer_1"
        class="brandIcon"
        height="36"
        width="30"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 378.2 409.2"
    >
        <path
            class="shield-path"
            d="M378.2,234.43l-.16-.76A87.27,87.27,0,1,1,333.89,71.12a88.75,88.75,0,0,1,13.53,1c17.3-25.7,2.35-61.87,2.35-61.87C340.51,36.74,307.45,42,307.45,42,251.25-2.93,189.1,0,189.1,0S127-2.93,70.75,42c0,0-33.06-5.29-42.32-31.74,0,0-15,36.17,2.35,61.87a88.62,88.62,0,0,1,13.52-1A87.28,87.28,0,1,1,.15,233.67l-.15.76s25.13,56.2,60.83,68.1c0,0-15.87,2.64-24.47,0,0,0,20.5,37.69,54.88,54.88,0,0-4.63,7.94-11.24,11.24,0,0,87.28,19,109.1,40.55,21.82-21.6,109.09-40.55,109.09-40.55-6.61-3.3-11.24-11.24-11.24-11.24,34.38-17.19,54.88-54.88,54.88-54.88-8.6,2.64-24.46,0-24.46,0C353.07,290.63,378.2,234.43,378.2,234.43ZM189.1,259.56c-10.58-49.59-48.6-73.73-48.6-73.73,20.83-21.49,48.6-23.63,48.6-23.63s27.77,2.14,48.6,23.63C237.7,185.83,199.68,210,189.1,259.56Z"
        />
        <path
            class="shield-path"
            d="M82.32,133.6A40.82,40.82,0,0,1,122.44,167c.13-1.59.21-3.18.21-4.79a58,58,0,1,0-33,52.37,40.82,40.82,0,1,1-7.3-81Z"
        />
        <path
            class="shield-path"
            d="M295.88,215.26a41,41,0,0,1-7.31-.69,58,58,0,1,0-33-52.37c0,1.61.08,3.2.21,4.79a40.81,40.81,0,1,1,40.12,48.27Z"
        />
    </svg>
</template>

<script>
export default {
    name: 'BrandIcon',
};
</script>

<style lang="scss">
@import 'resources/scss/toolbox.scss';

.brandIcon {
    .shield-path {
        fill: #4a5468;
        transition: fill 0.3s ease;
    }
}
</style> 